import * as React from 'react';
export const SESvg = React.forwardRef(function SESvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#217AB7',
        d: 'M2 2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FCD669',
        d: 'M16 9H7v5H4V9H0V6h4V2h3v4h9z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#A68527',
        d: 'M15 9V6h1v3h-1ZM4 13h3v1H4v-1ZM4 2h3v1H4V2ZM0 6h1v3H0V6Z',
        opacity: 0.1,
      }),
    ),
  );
});
SESvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
};
export var SE = {
  category: 'flag',
  colorable: false,
  name: 'SE',
  svg: SESvg,
};
